import React from 'react'
import { SVGIcon } from '~/utils/types'


export const ChevronDown = (props: SVGIcon) => (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.721 6.398a.689.689 0 01.957-.033l.057.056L8.948 9.97l3.325-3.556a.69.69 0 01.955-.062l.059.055c.263.274.283.71.058 1.009l-.052.062-3.843 4.11a.69.69 0 01-.97.05l-.057-.058-3.724-4.11a.788.788 0 01.022-1.071z"
      fillRule="evenodd"
    />
  </svg>
)
